var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload_grid" },
    [
      _c(
        "van-uploader",
        {
          staticClass: "uploader",
          attrs: {
            "result-type": "file",
            accept: "*",
            "after-read": _vm.uploaderAfterRead
          }
        },
        [
          _c("div", { staticClass: "upload_tile" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "plus" }, [_vm._v("+")]),
              _vm._v(" "),
              _c("div", { staticClass: "caption" }, [_vm._v("上传图片或视频")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.attachmentList, function(each, i) {
        return _c("div", { key: i, staticClass: "uploaded_tile" }, [
          _vm.isImage(each)
            ? _c("img", {
                staticClass: "upload_img",
                attrs: { src: each.filePath }
              })
            : _c(
                "a",
                {
                  staticClass: "file_link",
                  attrs: { target: "_blank", href: each.filePath }
                },
                [_vm._v(_vm._s(each.fileName))]
              )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f37eece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f37eece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketUploadBig.vue
// module id = 610
// module chunks = 75